/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionSubServiceSummaryList } from '../../models/subscription-sub-service-summary-list';

export interface GetAllSubscriptionSubServicesSummaries$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getAllSubscriptionSubServicesSummaries(http: HttpClient, rootUrl: string, params: GetAllSubscriptionSubServicesSummaries$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceSummaryList>> {
  const rb = new RequestBuilder(rootUrl, getAllSubscriptionSubServicesSummaries.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionSubServiceSummaryList>;
    })
  );
}

getAllSubscriptionSubServicesSummaries.PATH = '/subscriptions/{uid}/sub-service/summary';
